import * as React from "react";
import { WizardHero } from "./views/WizardHero";
import { DestinationHeroGallery } from "./views/DestinationHeroGallery";
import { DestinationHeroProps } from "./typings";

export enum ModelView {
  Wizard = "wizard",
  Gallery = "gallery",
}

export const DestinationHero = (props: DestinationHeroProps) => {
  const { flexComponent, context } = props;
  const model = flexComponent && flexComponent.model;
  const content = model && model.content;

  if (!model || model.empty || !content) {
    return null;
  }

  return model.view === ModelView.Gallery ? (
    <DestinationHeroGallery flexComponent={flexComponent} context={context} />
  ) : (
    <WizardHero flexComponent={flexComponent} context={context} />
  );
};

export default DestinationHero;
